(function() {
  'use strict';

  console.log('Persistent Audio: Script loaded');

  let persistentAudio = null;
  let isRestoredPlayback = false;

  function init() {
    // Create persistent audio element
    persistentAudio = document.createElement('audio');
    persistentAudio.id = 'persistent-audio';
    document.body.appendChild(persistentAudio);
    
    // Sync button state with persistent audio
    persistentAudio.addEventListener('play', () => syncButtons(true));
    persistentAudio.addEventListener('pause', () => syncButtons(false));
    persistentAudio.addEventListener('ended', () => {
      syncButtons(false);
      isRestoredPlayback = false;
    });
    
    // Header button click handler
    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-header-player]')) return;
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      if (isRestoredPlayback && persistentAudio.src) {
        if (persistentAudio.paused) {
          persistentAudio.play();
        } else {
          persistentAudio.pause();
        }
        return;
      }
      
      const pageAudio = document.querySelector('[data-audio]');
      if (pageAudio && pageAudio.src) {
        if (pageAudio.paused) {
          pageAudio.play();
        } else {
          pageAudio.pause();
        }
      }
    }, true);
    
    // Watch page audio
    document.addEventListener('play', function(e) {
      if (e.target === persistentAudio) return;
      if (e.target.tagName !== 'AUDIO') return;
      
      if (isRestoredPlayback) {
        persistentAudio.pause();
        isRestoredPlayback = false;
      }
      
      setTimeout(() => syncButtons(true), 50);
    }, true);
    
    document.addEventListener('pause', function(e) {
      if (e.target === persistentAudio) return;
      if (e.target.tagName !== 'AUDIO') return;
      
      if (!e.target.seeking) {
        setTimeout(() => syncButtons(false), 50);
      }
    }, true);
    
    // Intercept link clicks to start persistent audio BEFORE navigation
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      if (!link) return;
      
      // Skip if not a regular navigation link
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
      if (link.target === '_blank') return;
      if (e.ctrlKey || e.metaKey || e.shiftKey) return;
      
      // Check if music is playing
      const pageAudio = document.querySelector('[data-audio]');
      if (!pageAudio || pageAudio.paused || !pageAudio.src) return;
      
      // Start persistent audio immediately (before page unloads)
      console.log('Persistent Audio: Pre-loading for navigation');
      persistentAudio.src = pageAudio.src;
      persistentAudio.currentTime = pageAudio.currentTime;
      persistentAudio.volume = pageAudio.volume;
      persistentAudio.play().catch(() => {});
      
      // Save state
      const state = {
        src: pageAudio.src,
        time: pageAudio.currentTime,
        volume: pageAudio.volume
      };
      sessionStorage.setItem('persistentAudioState', JSON.stringify(state));
      
    }, true);
    
    // Backup save on beforeunload
    window.addEventListener('beforeunload', saveState);
    window.addEventListener('pagehide', saveState);
    
    // Restore state on page load
    restoreState();
    
    console.log('Persistent Audio: Ready');
  }

  function saveState() {
    // Only save if not already saved by click handler
    if (sessionStorage.getItem('persistentAudioState')) return;
    
    if (isRestoredPlayback && persistentAudio && persistentAudio.src && !persistentAudio.paused) {
      const state = {
        src: persistentAudio.src,
        time: persistentAudio.currentTime,
        volume: persistentAudio.volume
      };
      sessionStorage.setItem('persistentAudioState', JSON.stringify(state));
      return;
    }
    
    const pageAudio = document.querySelector('[data-audio]');
    if (pageAudio && pageAudio.src && !pageAudio.paused) {
      const state = {
        src: pageAudio.src,
        time: pageAudio.currentTime,
        volume: pageAudio.volume
      };
      sessionStorage.setItem('persistentAudioState', JSON.stringify(state));
    }
  }

  function restoreState() {
    const saved = sessionStorage.getItem('persistentAudioState');
    if (!saved) return;
    
    sessionStorage.removeItem('persistentAudioState');
    
    try {
      const state = JSON.parse(saved);
      if (!state.src) return;
      
      console.log('Persistent Audio: Restoring state');
      
      // If persistent audio is already playing (from pre-load), keep it going
      if (!persistentAudio.paused && persistentAudio.src) {
        console.log('Persistent Audio: Already playing from pre-load');
        isRestoredPlayback = true;
        syncButtons(true);
        
        // Transfer to page audio after a delay
        setTimeout(() => {
          transferToPageAudio({
            src: persistentAudio.src,
            time: persistentAudio.currentTime,
            volume: persistentAudio.volume
          });
        }, 500);
        return;
      }
      
      // Otherwise start fresh
      setTimeout(() => {
        transferToPageAudio(state);
      }, 500);
      
    } catch(e) {
      console.error('Persistent Audio: Failed to restore', e);
    }
  }

  function transferToPageAudio(state) {
    const pageAudio = document.querySelector('[data-audio]');
    
    if (pageAudio) {
      console.log('Persistent Audio: Transferring to page audio');
      
      // Get current time from persistent if it's playing
      const currentTime = (!persistentAudio.paused && persistentAudio.src) 
        ? persistentAudio.currentTime 
        : state.time;
      
      pageAudio.src = state.src;
      pageAudio.volume = state.volume || 1;
      
      pageAudio.addEventListener('loadedmetadata', function onLoaded() {
        pageAudio.removeEventListener('loadedmetadata', onLoaded);
        pageAudio.currentTime = currentTime || 0;
        
        pageAudio.play().then(() => {
          console.log('Persistent Audio: Playback transferred to page audio');
          
          // Stop persistent audio
          persistentAudio.pause();
          isRestoredPlayback = false;
          
          pageAudio.dispatchEvent(new Event('play', { bubbles: true }));
        }).catch(e => {
          console.log('Persistent Audio: Transfer failed, using persistent', e);
          playPersistent(state);
        });
      });
      
      pageAudio.load();
    } else {
      playPersistent(state);
    }
  }

  function playPersistent(state) {
    if (!persistentAudio.paused) {
      isRestoredPlayback = true;
      syncButtons(true);
      return;
    }
    
    persistentAudio.src = state.src;
    persistentAudio.volume = state.volume || 1;
    
    persistentAudio.addEventListener('loadedmetadata', function onLoaded() {
      persistentAudio.removeEventListener('loadedmetadata', onLoaded);
      persistentAudio.currentTime = state.time || 0;
      
      persistentAudio.play().then(() => {
        console.log('Persistent Audio: Playback resumed (persistent)');
        isRestoredPlayback = true;
        syncButtons(true);
      }).catch(e => {
        console.log('Persistent Audio: Auto-resume blocked', e);
      });
    });
  }

  function syncButtons(isPlaying) {
    document.querySelectorAll('[data-header-player]').forEach(btn => {
      if (isPlaying) {
        btn.classList.add('is-playing');
      } else {
        btn.classList.remove('is-playing');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();